import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import "./expression-error-alert-details.style.less";

const { Paragraph } = Typography;

export const ExpressionErrorAlertDetails = ({
  message,
}: {
  message: string;
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="expression-error-alert-details">
      <Button
        type="link"
        size="small"
        className="expression-error-alert-details__toggle"
        icon={expanded ? <DownOutlined /> : <RightOutlined />}
        aria-expanded={expanded}
        onClick={() => setExpanded((value) => !value)}
      >
        {t("expression:technicalDetails")}
      </Button>

      {expanded && (
        <Paragraph
          className="expression-error-alert-details__message"
          copyable={{ text: message }}
        >
          {message}
        </Paragraph>
      )}
    </div>
  );
};
